import { render, staticRenderFns } from "./inheritedList.vue?vue&type=template&id=27e7213d&scoped=true&"
import script from "./inheritedList.vue?vue&type=script&lang=js&"
export * from "./inheritedList.vue?vue&type=script&lang=js&"
import style0 from "./inheritedList.vue?vue&type=style&index=0&id=27e7213d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e7213d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27e7213d')) {
      api.createRecord('27e7213d', component.options)
    } else {
      api.reload('27e7213d', component.options)
    }
    module.hot.accept("./inheritedList.vue?vue&type=template&id=27e7213d&scoped=true&", function () {
      api.rerender('27e7213d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/clientInheritRecord/detail/inheritedList.vue"
export default component.exports